var map = {
	"./Adverse pregnancy outcomes.svg": [
		76048,
		1,
		6048
	],
	"./AdversePregnancyOutcomes": [
		79848,
		9,
		9848
	],
	"./AdversePregnancyOutcomes.js": [
		79848,
		9,
		9848
	],
	"./All cause deaths.svg": [
		67899,
		1,
		7899
	],
	"./AllCauseDeaths": [
		2187,
		9,
		2187
	],
	"./AllCauseDeaths.js": [
		2187,
		9,
		2187
	],
	"./Allergies": [
		66373,
		9,
		6373
	],
	"./Allergies.js": [
		66373,
		9,
		6373
	],
	"./Allergies.svg": [
		2543,
		1,
		2543
	],
	"./Bone health & immune system strength.svg": [
		17558,
		1,
		7558
	],
	"./BoneHealth&ImmuneSystemStrength": [
		32092,
		9,
		2092
	],
	"./BoneHealth&ImmuneSystemStrength.js": [
		32092,
		9,
		2092
	],
	"./Cardiovascular deaths.svg": [
		69088,
		1,
		9088
	],
	"./Cardiovascular diseases.svg": [
		87928,
		1,
		7928
	],
	"./CardiovascularDeaths": [
		47965,
		9,
		7965
	],
	"./CardiovascularDeaths.js": [
		47965,
		9,
		7965
	],
	"./CardiovascularDiseases": [
		95666,
		9,
		5666
	],
	"./CardiovascularDiseases.js": [
		95666,
		9,
		5666
	],
	"./Cerebrovascular deaths.svg": [
		2827,
		1,
		2827
	],
	"./CerebrovascularDeaths": [
		53869,
		9,
		3869
	],
	"./CerebrovascularDeaths.js": [
		53869,
		9,
		3869
	],
	"./Cognitive performance & the ability to learn.svg": [
		57474,
		1,
		7474
	],
	"./CognitivePerformance&TheAbilityToLearn": [
		72495,
		9,
		2495
	],
	"./CognitivePerformance&TheAbilityToLearn.js": [
		72495,
		9,
		2495
	],
	"./Cold related deaths.svg": [
		36218,
		1,
		6218
	],
	"./ColdRelatedDeaths": [
		11947,
		9,
		1947
	],
	"./ColdRelatedDeaths.js": [
		11947,
		9,
		1947
	],
	"./ColdRelatedMorbidity": [
		73478,
		9,
		3478
	],
	"./ColdRelatedMorbidity.js": [
		73478,
		9,
		3478
	],
	"./ColdRelatedMorbidity.svg": [
		3658,
		1,
		3658
	],
	"./ColdRelatedMortality": [
		97074,
		9,
		7074
	],
	"./ColdRelatedMortality.js": [
		97074,
		9,
		7074
	],
	"./ColdRelatedMortality.svg": [
		15292,
		1,
		5292
	],
	"./Communicable diseases.svg": [
		52056,
		1,
		2056
	],
	"./CommunicableDiseases": [
		21631,
		9,
		1631
	],
	"./CommunicableDiseases.js": [
		21631,
		9,
		1631
	],
	"./Diabetes": [
		6353,
		9,
		6353
	],
	"./Diabetes.js": [
		6353,
		9,
		6353
	],
	"./Diabetes.svg": [
		96321,
		1,
		6321
	],
	"./Infections caused by pathogenic organisms.svg": [
		94700,
		1,
		4700
	],
	"./InfectionsCausedByPathogenicOrganisms": [
		77701,
		9,
		7701
	],
	"./InfectionsCausedByPathogenicOrganisms.js": [
		77701,
		9,
		7701
	],
	"./Injuries": [
		83582,
		9,
		3582
	],
	"./Injuries.js": [
		83582,
		9,
		3582
	],
	"./Injuries.svg": [
		49570,
		1,
		9570
	],
	"./Injury": [
		21208,
		9,
		1208
	],
	"./Injury.js": [
		21208,
		9,
		1208
	],
	"./Injury.svg": [
		36838,
		1,
		6838
	],
	"./Lung cancer.svg": [
		66810,
		1,
		6810
	],
	"./LungCancer": [
		72946,
		9,
		2946
	],
	"./LungCancer.js": [
		72946,
		9,
		2946
	],
	"./Mental health disorders.svg": [
		6313,
		1,
		6313
	],
	"./MentalHealthDisorders": [
		19064,
		9,
		9064
	],
	"./MentalHealthDisorders.js": [
		19064,
		9,
		9064
	],
	"./Non-communicable diseases.svg": [
		26215,
		1,
		6215
	],
	"./NonCommunicableDiseases": [
		54952,
		9,
		4952
	],
	"./NonCommunicableDiseases.js": [
		54952,
		9,
		4952
	],
	"./Obesity": [
		38329,
		9,
		8329
	],
	"./Obesity.js": [
		38329,
		9,
		8329
	],
	"./Obesity.svg": [
		59994,
		1,
		9994
	],
	"./Opthalmic diseases.svg": [
		82486,
		1,
		2486
	],
	"./OpthalmicDiseases": [
		84586,
		9,
		4586
	],
	"./OpthalmicDiseases.js": [
		84586,
		9,
		4586
	],
	"./Respiratory deaths.svg": [
		91120,
		1,
		1120
	],
	"./Respiratory diseases.svg": [
		95059,
		1,
		5059
	],
	"./RespiratoryDeaths": [
		80923,
		9,
		923
	],
	"./RespiratoryDeaths.js": [
		80923,
		9,
		923
	],
	"./RespiratoryDiseases": [
		46376,
		9,
		6376
	],
	"./RespiratoryDiseases.js": [
		46376,
		9,
		6376
	],
	"./Skin cancer.svg": [
		96506,
		1,
		6506
	],
	"./SkinCancer": [
		1331,
		9,
		1331
	],
	"./SkinCancer.js": [
		1331,
		9,
		1331
	],
	"./Sleep disruption & disorders.svg": [
		49681,
		1,
		9681
	],
	"./SleepDisruption&Disorders": [
		56555,
		9,
		6555
	],
	"./SleepDisruption&Disorders.js": [
		56555,
		9,
		6555
	],
	"./Vector-BorneDiseases": [
		92911,
		9,
		2911
	],
	"./Vector-BorneDiseases.js": [
		92911,
		9,
		2911
	],
	"./Vector-borne diseases.svg": [
		94853,
		1,
		4853
	],
	"./Wellbeing": [
		63475,
		9,
		3475
	],
	"./Wellbeing.js": [
		63475,
		9,
		3475
	],
	"./Wellbeing.svg": [
		54376,
		1,
		4376
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58641;
module.exports = webpackAsyncContext;